import { fork } from 'redux-saga/effects';
import { takeLatest } from 'redux-saga';

import * as actions from 'actions';
import * as api from 'api';

export default function* backgroundSaga(socket, request) {
  yield [
    fork(takeLatest, actions.LINKS_FETCH, request(api.linksFetch))
  ];
}



/** WEBPACK FOOTER **
 ** ./src/members/state/links/sagas.js
 **/